import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {
  UntypedFormGroup,
  AbstractControl,
  UntypedFormBuilder,
  Validators
} from '@angular/forms';
import { IArrayFiles } from 'src/app/shared/interfaces/array-files.interface';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { CustomerDataService } from 'src/app/shared/services/customer-data.service';
import { routesData } from 'src/app/shared/resources/routes.constant';
import { IFilesSQS } from 'src/app/shared/interfaces/files-sqs.interface';
import { GeneratePresignedUrlService } from 'src/app/shared/services/generate-presigned-url.service';
import { IFilesPreSignedUrl } from 'src/app/shared/interfaces/files-presignedurl.interface';
import { IPreSignedUrlObject } from 'src/app/shared/interfaces/presigned-url-object.interface';
import { UploadDocumentsDialogComponent } from '../dialogs/upload-documents-dialog/upload-documents-dialog.component';
import { EnumEconomicActivity } from 'src/app/shared/enums/economic-activity.enum';
import { UploadDocumentsErrorDialogComponent } from '../dialogs/upload-documents-error-dialog copy/upload-documents-error-dialog.component';
import { codesUploadDocuments } from 'src/app/shared/data/codes-upload-documentss.json';
import { IResponsePresignedUrl } from 'src/app/shared/interfaces/response-files-presigned-url.interface';
import { UploadDocumentsS3Service } from 'src/app/shared/services/upload-documents-s3.service';
import { IRequestValidateDocument } from 'src/app/shared/interfaces/request-validate-document.interface';
import { ValidateDocumentService } from 'src/app/shared/services/validate-document.service';
import { MoreInfoService } from 'src/app/shared/services/more-info.service';
import { DocumentsInfoService } from 'src/app/shared/services/documents-info.service';
import { UploadDniS3Service } from 'src/app/shared/services/upload-dni-s3.service';
import { ISqs } from 'src/app/shared/interfaces/sqs.interface';
import { SqsService } from 'src/app/shared/services/sqs.service';
import { codesUploadDocumentsToCharge } from 'src/app/shared/data/codes-documents.json';
import { ConvertPdfToImageService } from 'src/app/shared/services/convert-pdf-to-image.service';
import { IRequestUploadDNI } from 'src/app/shared/interfaces/request-upload-dni.interface';
import { DocumentsToChargeDialogComponent } from '../dialogs/documents-to-charge-dialog/documents-to-charge-dialog.component';
import { DialogOptionsService } from 'src/app/shared/services/dialog-options.service';
import { Observable } from 'rxjs';
import { RegExps } from 'src/app/shared/resources/regexps.constant';
import { Base64HeaderCodes } from 'src/app/shared/utils/base64-header-codes';
import { AnalyticService } from 'src/app/shared/services/analytic.service';

@Component({
  selector: 'app-upload-documents-presigned',
  templateUrl: './upload-documents-presigned.component.html',
  styleUrls: ['./upload-documents-presigned.component.scss']
})
export class UploadDocumentsPresignedComponent implements OnInit {
  putUrls: IPreSignedUrlObject[] = [];
  uploadDocumentsPresignedForm: UntypedFormGroup = {} as UntypedFormGroup;
  frontIdList: IArrayFiles[] = [];
  backIdList: IArrayFiles[] = [];
  completeDocIdList: IArrayFiles[] = [];
  workCertificatesDocsList: IArrayFiles[] = [];
  independentDocsList: IArrayFiles[] = [];
  radioButtonsWorkDocs: any[] = [];
  radioButtonsIndependentDocs: any[] = [];
  filesLoaded: any[] = [];
  frontIdB64: string = '';
  backIdB64: string = '';
  uploadIDSuccess: boolean = false;
  allowedFile = ['image/jpeg', 'image/png', 'application/pdf'];
  allowedFileID = ['image/jpeg', 'image/png', 'application/pdf'];
  readonly MAX_SIZE = 10;
  readonly MAX_SIZE_ID = 14;
  readonly MAX_FILES = 3;
  attachId: boolean = false;
  attachWorkDocumentsData: boolean = false;
  attachIndependentDocuments: boolean = false;
  public responseDocumentsToCharge: any;
  presignedFlag: number = 0;
  frontIdValid: boolean = false;
  backIdValid: boolean = false;
  docsValidCounter: number = 0;
  reqUploadDNIS3: IRequestUploadDNI = {};

  attemptExceededUrlPresigned: boolean = false;
  attemptExceededConvertPdf: boolean = false;
  attemptExceededPutFile: boolean = false;
  base64Codes = new Base64HeaderCodes();

  @ViewChild('frontIdPic') frontIdPic: ElementRef<HTMLInputElement> =
    {} as ElementRef;
  @ViewChild('backIdPic') backIdPic: ElementRef<HTMLInputElement> =
    {} as ElementRef;
  @ViewChild('workCertificate') workCertificate: ElementRef<HTMLInputElement> =
    {} as ElementRef;
  @ViewChild('independentDocument')
  independentDocument: ElementRef<HTMLInputElement> = {} as ElementRef;
  documentsDialogRef:
    | MatDialogRef<DocumentsToChargeDialogComponent>
    | undefined;

  get controlFrontIdPic(): AbstractControl {
    return this.uploadDocumentsPresignedForm.get('attachIdGroup.frontIdPic');
  }

  get fileFrontIdPic(): FileList {
    return this.frontIdPic.nativeElement.files.length
      ? this.frontIdPic.nativeElement.files
      : null;
  }

  get controlBackIdPic(): AbstractControl {
    return this.uploadDocumentsPresignedForm.get('attachIdGroup.backIdPic');
  }

  get fileBackIdPic(): FileList {
    return this.backIdPic.nativeElement.files.length
      ? this.backIdPic.nativeElement.files
      : null;
  }

  get controlWorkCertificate(): AbstractControl {
    return this.uploadDocumentsPresignedForm.get(
      'attachWorkDocuments.workCertificate'
    );
  }

  get fileWorkCertificate(): FileList {
    return this.workCertificate?.nativeElement.files.length
      ? this.workCertificate.nativeElement.files
      : null;
  }

  get controlTypeWorkCertificate(): AbstractControl {
    return this.uploadDocumentsPresignedForm.get(
      'attachWorkDocuments.typeWorkCertificate'
    );
  }

  get controlIndependentDocument(): AbstractControl {
    return this.uploadDocumentsPresignedForm.get(
      'attachIndependentDocuments.independentDocument'
    );
  }

  get fileIndependentDocument(): FileList {
    return this.independentDocument?.nativeElement.files.length
      ? this.independentDocument.nativeElement.files
      : null;
  }

  get controlTypeIndependentDocument(): AbstractControl {
    return this.uploadDocumentsPresignedForm.get(
      'attachIndependentDocuments.typeIndependentDocument'
    );
  }

  get groupAttachIdGroup(): AbstractControl {
    return this.uploadDocumentsPresignedForm.get('attachIdGroup');
  }

  get groupAttachWorkDocuments(): AbstractControl {
    return this.uploadDocumentsPresignedForm.get('attachWorkDocuments');
  }

  get groupAttachIndependentDocuments(): AbstractControl {
    return this.uploadDocumentsPresignedForm.get('attachIndependentDocuments');
  }

  get sqsDniObject(): IFilesSQS[] {
    return [
      {
        documentaryCode: codesUploadDocuments.identificationCard.code,
        filename: `${codesUploadDocuments.identificationCard.prefix}-${this.customerDataSvc.customerData.numberDNI}.pdf`
      }
    ];
  }

  constructor(
    private fb: UntypedFormBuilder,
    private dialog: MatDialog,
    private router: Router,
    public breakpointObserver: BreakpointObserver,
    private customerDataSvc: CustomerDataService,
    private generatePresignedUrl: GeneratePresignedUrlService,
    public uploadDocumentsS3: UploadDocumentsS3Service,
    public validateDocumentsService: ValidateDocumentService,
    public initParamsService: MoreInfoService,
    private documentsInfoService: DocumentsInfoService,
    private uploadDNIS3: UploadDniS3Service,
    public sqsService: SqsService,
    public convertPDF2Image: ConvertPdfToImageService,
    private moreInfoService: MoreInfoService,
    private dialogOptionsService: DialogOptionsService,
    public analytic: AnalyticService
  ) {}

  ngOnInit(): void {
    this.customerDataSvc.customerData = {
      ...this.customerDataSvc.customerData,
      stepInUploadDocuments: true
    };

    this.responseDocumentsToCharge =
      this.documentsInfoService.getDocumentInfo();
    this.constructForm();
    this.disableAllGroups();
    if (!this.moreInfoService.moreInfoData.failedDocumentsToCharge) {
      this.enableDocumentsToCharge();
    } else {
      this.enableOrDisableSection();
    }
    this.valueChanges();
  }

  constructForm(): void {
    this.uploadDocumentsPresignedForm = this.fb.group({
      attachIdGroup: this.fb.group(
        {
          frontIdPic: [null],
          backIdPic: [null]
        }
        // { validators: CustomValidators.groupNotEqual },
      ),
      attachWorkDocuments: this.fb.group({
        typeWorkCertificate: [null, [Validators.required]],
        workCertificate: [null]
      }),
      attachIndependentDocuments: this.fb.group({
        typeIndependentDocument: [null, [Validators.required]],
        independentDocument: [null]
      })
    });
  }

  disableAllGroups(): void {
    this.groupAttachIdGroup.disable();
    this.groupAttachWorkDocuments.disable();
    this.groupAttachIndependentDocuments.disable();
  }

  setAttachIdGroup(identification: boolean): void {
    if (identification) {
      this.groupAttachIdGroup.enable();
      this.uploadIDSuccess = false;
    } else {
      this.groupAttachIdGroup.disable();
      this.uploadIDSuccess = true;
    }
  }

  enableDocumentsToCharge(): void {
    this.setAttachIdGroup(
      this.responseDocumentsToCharge.documents.identification
    );

    if (
      this.responseDocumentsToCharge.documents.finantialDocs &&
      this.responseDocumentsToCharge.clientDocuments.length > 0
    ) {
      this.responseDocumentsToCharge.clientDocuments.forEach((element: any) => {
        if (element.documentaryCode !== 254) {
          this.radioButtonsWorkDocs.push({
            name: element.documentDescription,
            code: element.documentaryCode,
            prefix: this.getPrefix(
              codesUploadDocumentsToCharge,
              element.documentaryCode
            )
          });
        }
      });
      this.groupAttachWorkDocuments.enable();
    }
  }

  getPrefix(array: any[], documentaryCode: number): string {
    let prefix = 'XX';
    for (const el of array) {
      if (el.code === documentaryCode) {
        prefix = el.prefix;
        break;
      }
    }

    return prefix;
  }

  enableOrDisableSection(): void {
    try {
      if (this.customerDataSvc.customerData.documentRequiredIndicator) {
        this.attachId = true;
        this.groupAttachIdGroup.enable();
        this.uploadIDSuccess = false;
      } else {
        this.attachId = false;
        this.groupAttachIdGroup.disable();
        this.uploadIDSuccess = true;
      }
      this.setDocsByEconomicActivity();
      if (
        this.customerDataSvc.customerData.economicActivityInformation
          .economicActivity === EnumEconomicActivity.IndependentWithBusiness
      ) {
        this.attachIndependentDocuments = true;
        this.groupAttachIndependentDocuments.enable();

        this.radioButtonsIndependentDocs = [
          codesUploadDocuments.camaraComercio,
          codesUploadDocuments.rut
        ];
      } else {
        this.attachIndependentDocuments = false;
        this.groupAttachIndependentDocuments.disable();
      }
    } catch (error) {
      let errorMessage = '';
      if (error?.message !== undefined) {
        errorMessage = error.message;
      }
      this.analytic.uTagLinkError(
        'Error catch cargue de documentos prefirmados ' + errorMessage,
        'error_tech_page'
      );
      this.router.navigate([routesData.ERRORS.GENERAL_ERROR.redirectPath]);
    }
  }

  areRequiredDocs() {
    if (this.customerDataSvc.customerData.documentRequiredIndicator) {
      this.attachId = true;
      this.groupAttachIdGroup.enable();
      this.uploadIDSuccess = false;
    } else {
      this.attachId = false;
      this.groupAttachIdGroup.disable();
      this.uploadIDSuccess = true;
    }
  }

  setDocsByEconomicActivity() {
    switch (
      this.customerDataSvc.customerData.economicActivityInformation
        .economicActivity
    ) {
      case EnumEconomicActivity.Employee:
        this.attachWorkDocumentsData = true;
        this.groupAttachWorkDocuments.enable();
        this.radioButtonsWorkDocs = [
          codesUploadDocuments.workCertificate,
          codesUploadDocuments.incomeCertificate,
          codesUploadDocuments.payrollVouchers,
          codesUploadDocuments.incomeStatement
        ];
        break;
      case EnumEconomicActivity.Pensioner:
        this.attachWorkDocumentsData = true;
        this.groupAttachWorkDocuments.enable();
        this.radioButtonsWorkDocs = [
          codesUploadDocuments.settlementResolution,
          codesUploadDocuments.pensionVouchers,
          codesUploadDocuments.incomeStatement
        ];
        break;
      case EnumEconomicActivity.Student:
      case EnumEconomicActivity.WorkHome:
        if (this.customerDataSvc.customerData.nonReportingPerson) {
          this.attachWorkDocumentsData = true;
          this.groupAttachWorkDocuments.enable();
          this.radioButtonsWorkDocs = [
            codesUploadDocuments.incomeCertificate,
            codesUploadDocuments.incomeStatement
          ];
        }
        break;
      case EnumEconomicActivity.Independent:
      case EnumEconomicActivity.IndependentWithBusiness:
        if (this.customerDataSvc.customerData.nonReportingPerson) {
          this.attachWorkDocumentsData = true;
          this.groupAttachWorkDocuments.enable();
          this.radioButtonsWorkDocs = [
            codesUploadDocuments.financialStatements,
            codesUploadDocuments.incomeStatement,
            codesUploadDocuments.incomeCertificate,
            codesUploadDocuments.contractOfService
          ];
        }
        break;
      default:
        this.attachWorkDocumentsData = false;
        this.groupAttachWorkDocuments.disable();
    }
  }

  validateErrorFrontDoc(isValid: boolean, val: any, file: File[]) {
    if (isValid) {
      if (val) {
        if (
          !this.hasErrorFiles(
            this.controlFrontIdPic,
            file,
            this.allowedFileID,
            this.MAX_SIZE_ID
          )
        ) {
          this.frontIdList = [
            {
              name: file[0].name,
              code: codesUploadDocuments.identificationCard.code,
              nameS3: `${codesUploadDocuments.identificationCard.prefix}-${
                this.customerDataSvc.customerData.numberDNI
              }-F.${file[0].name.split('.').pop()}`,
              file: file[0]
            }
          ];
          this.controlFrontIdPic.setErrors({ invalidFormat: false });
          this.validateAndUploadDni(this.frontIdList, true);
        }
      }
    }
    if (this.backIdList.length && this.frontIdList.length) {
      this.uploadIDSuccess = true;
    }
  }

  validateErrorBackDoc(isValid: boolean, val: any, file: File[]) {
    if (isValid) {
      if (val) {
        if (
          !this.hasErrorFiles(
            this.controlBackIdPic,
            file,
            this.allowedFileID,
            this.MAX_SIZE_ID
          )
        ) {
          this.backIdList = [
            {
              name: file[0].name,
              code: codesUploadDocuments.identificationCard.code,
              nameS3: `${codesUploadDocuments.identificationCard.prefix}-${
                this.customerDataSvc.customerData.numberDNI
              }-B.${file[0].name.split('.').pop()}`,
              file: file[0]
            }
          ];

          this.validateAndUploadDni(this.backIdList, true);
        }
      }
    }
    if (this.backIdList.length && this.frontIdList.length) {
      this.uploadIDSuccess = true;
    }
  }

  validateErrorWorkDoc(isValid: boolean[], arrayLoadFiles: IArrayFiles[]) {
    if (isValid.every((value) => value === true)) {
      this.workCertificatesDocsList = this.uniqueArray([
        ...arrayLoadFiles,
        ...this.workCertificatesDocsList
      ]).map((el: IArrayFiles, i) => {
        return {
          ...el,
          nameS3: `${this.controlTypeWorkCertificate.value?.prefix || null}-${
            this.customerDataSvc.customerData.numberDNI
          }-${i}.${el.name.split('.').pop()}`
        };
      });
    }
  }

  controlBackDoc() {
    this.controlBackIdPic.valueChanges.subscribe({
      next: (val) => {
        const file = this.fileBackIdPic
          ? Array.from(this.fileBackIdPic).slice(0)
          : [];
        let fileBase64: string = '';
        let isValid: boolean = false;
        if (file[0]) {
          this.toBase64(file[0]).subscribe({
            next: (res) => {
              if (typeof res !== 'string') return;
              fileBase64 = res.toString();
              isValid = this.isBase64FileValid(
                fileBase64,
                this.controlBackIdPic
              );
              setTimeout(() => {
                this.validateErrorBackDoc(isValid, val, file);
              }, 0);
            },
            error: (error) => {
              const errorMessage =
                error.message === undefined ? '' : error.message;
              if (errorMessage !== 'Unauthorized') {
                this.router.navigate([
                  routesData.ERRORS.GENERAL_ERROR.redirectPath
                ]);
              }
              this.analytic.uTagLinkError(
                'Error servicio de conversión a base64 parte trasera: ' + error,
                'error_tech_page'
              );
              this.router.navigate([
                routesData.ERRORS.GENERAL_ERROR.redirectPath
              ]);
            }
          });
        }
      },
      error(error) {
        this.analytic.uTagLinkError(
          'Error al momento de cargar la parte trasera en el navegador: ' +
            error,
          'error_tech_page'
        );
        this.router.navigate([routesData.ERRORS.GENERAL_ERROR.redirectPath]);
      }
    });
  }

  handleErrorWorkDoc(error: any) {
    const errorMessage = error.message === undefined ? '' : error.message;
    if (errorMessage !== 'Unauthorized') {
      this.router.navigate([routesData.ERRORS.GENERAL_ERROR.redirectPath]);
    }
    this.analytic.uTagLinkError(
      'Error servicio de conversión a base64 documentos financieros: ' + error,
      'error_tech_page'
    );
    this.router.navigate([routesData.ERRORS.GENERAL_ERROR.redirectPath]);
  }

  controWorkDoc() {
    this.controlWorkCertificate.valueChanges.subscribe({
      next: (val) => {
        if (val) {
          if (
            !this.hasErrorFiles(
              this.controlWorkCertificate,
              this.fileWorkCertificate
            )
          ) {
            const arrayLoadFiles: IArrayFiles[] = Array.from(
              this.fileWorkCertificate
            ).map((el) => {
              return {
                name: el.name,
                code: this.controlTypeWorkCertificate.value?.code || null,
                nameS3: '',
                file: el
              } as IArrayFiles;
            });

            let fileBase64: string = '';
            let isValid: boolean[] = [];
            if (arrayLoadFiles) {
              arrayLoadFiles.forEach((fileTyped: any) => {
                this.toBase64(fileTyped.file).subscribe({
                  next: (res) => {
                    if (typeof res !== 'string') return;
                    fileBase64 = res.toString();
                    isValid.push(
                      this.isBase64FileValid(
                        fileBase64,
                        this.controlWorkCertificate
                      )
                    );
                    setTimeout(() => {
                      this.validateErrorWorkDoc(isValid, arrayLoadFiles);
                    }, 0);
                  },
                  error: (error) => {
                    this.handleErrorWorkDoc(error);
                  }
                });
              });
            }
          }
        }
      },
      error(error) {
        this.analytic.uTagLinkError(
          'Error al momento de cargar documentos financieros en el navegador: ' +
            error,
          'error_tech_page'
        );
        this.router.navigate([routesData.ERRORS.GENERAL_ERROR.redirectPath]);
      }
    });
  }

  controlIndependentDoc() {
    this.controlIndependentDocument.valueChanges.subscribe({
      next: (val) => {
        if (val) {
          if (
            !this.hasErrorFiles(
              this.controlIndependentDocument,
              this.fileIndependentDocument
            )
          ) {
            const arrayLoadFiles: IArrayFiles[] = Array.from(
              this.fileIndependentDocument
            ).map((el) => {
              return {
                name: el.name,
                code: this.controlTypeIndependentDocument.value?.code || null,
                nameS3: '',
                file: el
              } as IArrayFiles;
            });

            this.independentDocsList = this.uniqueArray([
              ...arrayLoadFiles,
              ...this.independentDocsList
            ]).map((el: IArrayFiles, i) => {
              return {
                ...el,
                nameS3: `${
                  this.controlTypeIndependentDocument.value?.prefix || null
                }-${this.customerDataSvc.customerData.numberDNI}-${i}.${el.name
                  .split('.')
                  .pop()}`
              };
            });
          }
        }
      },
      error(error) {
        this.analytic.uTagLinkError(
          'Error al momento de cargar documentos de independiente en el navegador: ' +
            error,
          'error_tech_page'
        );
        this.router.navigate([routesData.ERRORS.GENERAL_ERROR.redirectPath]);
      }
    });
  }

  valueChanges(): void {
    this.controlFrontIdPic.valueChanges.subscribe({
      next: (val) => {
        const file = this.fileFrontIdPic
          ? Array.from(this.fileFrontIdPic).slice(0)
          : [];
        let fileBase64: string = '';
        let isValid: boolean = false;
        if (file[0]) {
          this.toBase64(file[0]).subscribe({
            next: (res) => {
              if (typeof res !== 'string') return;
              fileBase64 = res.toString();
              isValid = this.isBase64FileValid(
                fileBase64,
                this.controlFrontIdPic
              );
              setTimeout(() => {
                this.validateErrorFrontDoc(isValid, val, file);
              }, 0);
            },
            error: (error) => {
              this.analytic.uTagLinkError(
                'Error servicio de conversión a base64 parte frontal: ' + error,
                'error_tech_page'
              );
              this.router.navigate([
                routesData.ERRORS.GENERAL_ERROR.redirectPath
              ]);
            }
          });
        }
      },
      error: (error) => {
        this.analytic.uTagLinkError(
          'Error al momento de cargar la parte frontal en el navegador: ' +
            error,
          'error_tech_page'
        );
        this.router.navigate([routesData.ERRORS.GENERAL_ERROR.redirectPath]);
      }
    });

    this.controlBackDoc();
    this.controWorkDoc();
    this.controlIndependentDoc();

    this.controlTypeWorkCertificate.valueChanges.subscribe({
      next: () => {
        this.workCertificatesDocsList = [];
        this.controlWorkCertificate.reset();
      }
    });

    this.controlTypeIndependentDocument.valueChanges.subscribe({
      next: () => {
        this.independentDocsList = [];
        this.controlIndependentDocument.reset();
      }
    });
  }

  openTuto(): void {
    this.dialog.open(UploadDocumentsDialogComponent, {
      data: {
        attachId: this.attachId,
        attachWorkDocuments: this.attachWorkDocumentsData,
        attachIndependentDocuments: this.attachIndependentDocuments
      },
      panelClass: 'dialog-overlay',
      disableClose: true,
      maxWidth: this.breakpointObserver.isMatched('(max-width: 480px)')
        ? '100vw'
        : '480px'
    });
  }

  showDialogErrorFiles(): void {
    this.dialog.open(UploadDocumentsErrorDialogComponent, {
      panelClass: ['dialog-overlay', 'dialog-with-icon', 'dialog-error'],
      disableClose: true,
      maxWidth: this.breakpointObserver.isMatched('(max-width: 480px)')
        ? '100vw'
        : '480px'
    });
  }

  isBase64FileValid(base64String: string, control: AbstractControl): boolean {
    const base64Match = RegExp(RegExps.DOCUMENT_FILE_EXTENSION).exec(
      base64String
    );
    if (!base64Match) {
      control.setErrors({ invalidFormat: true });
      return false;
    }
    const dataView = new DataView(this.base64ToArrayBuffer(base64Match[2]));

    switch (base64Match[1]) {
      case this.base64Codes.JPEG_TYPE:
      case this.base64Codes.PNG_TYPE: {
        let matchFormat: boolean = false;
        for (let jpegHeader of this.base64Codes.JPEG) {
          if (dataView.getUint32(0).toString(16) === jpegHeader) {
            matchFormat = true;
            break;
          }
        }

        if (dataView.getUint32(0).toString(16) === this.base64Codes.PNG) {
          matchFormat = true;
        }

        if (matchFormat) {
          return true;
        } else {
          control.setErrors({ invalidFormat: true });
          return false;
        }
      }
      case this.base64Codes.PDF_TYPE: {
        const signature = dataView.getUint32(0).toString(16);
        if (signature === this.base64Codes.PDF) {
          return true;
        } else {
          control.setErrors({ invalidFormat: true });
          return false;
        }
      }
    }
    return false;
  }

  base64ToArrayBuffer(base64: string): ArrayBuffer {
    const binaryString = window.atob(base64);
    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes.buffer;
  }

  onSubmit(): void {
    if (
      (this.groupAttachWorkDocuments.enabled ||
        this.groupAttachIndependentDocuments.enabled) &&
      (this.workCertificatesDocsList.length || this.independentDocsList.length)
    ) {
      const filesS3: IFilesPreSignedUrl = {
        files: [
          ...this.workCertificatesDocsList.map((el) => el.nameS3),
          ...this.independentDocsList.map((el) => el.nameS3)
        ],
        personalDoc: false
      };
      this.createPresignedUrl(filesS3);
    } else if (this.frontIdList.length && this.backIdList.length) {
      this.reqUploadDNIS3.frontKey = this.frontIdList[0].nameS3;
      this.reqUploadDNIS3.backKey = this.backIdList[0].nameS3;

      this.uploadDocument();
    }
  }

  createPresignedUrl(filesS3: IFilesPreSignedUrl): void {
    this.generatePresignedUrl.createURL(filesS3).subscribe({
      next: (res) => {
        if (res.status === 201) {
          this.attemptExceededUrlPresigned = false;
          this.fileFormatForUpload(res.body as IResponsePresignedUrl);
        } else if (!this.attemptExceededUrlPresigned) {
          this.attemptExceededUrlPresigned = true;
          this.createPresignedUrl(filesS3);
        } else {
          this.analytic.uTagLinkError(
            'Error servicio generate-presigned-url status: ' + res.status,
            'error_tech_page'
          );
          this.router.navigate([routesData.ERRORS.GENERAL_ERROR.redirectPath]);
        }
      },
      error: (error) => {
        if (!this.attemptExceededUrlPresigned) {
          this.attemptExceededUrlPresigned = true;
          this.createPresignedUrl(filesS3);
        } else {
          let errorMessage = '';
          if (error?.message !== undefined) {
            errorMessage = error.message;
          }
          const event =
            errorMessage === 'Unauthorized'
              ? 'error_user_page'
              : 'error_tech_page';
          this.analytic.uTagLinkError(
            'Error servicio generate-presigned-url ' + errorMessage,
            event
          );
          if (errorMessage !== 'Unauthorized') {
            this.router.navigate([
              routesData.ERRORS.GENERAL_ERROR.redirectPath
            ]);
          }
        }
      }
    });
  }

  fileFormatForUpload(body: IResponsePresignedUrl): void {
    const filesForSend = [...this.workCertificatesDocsList];

    this.putUrls = body.preSignedUrl.map((a) => {
      const fileMatch = filesForSend.filter((b) => b.nameS3 === a.fileName)[0];
      return {
        urlS3: a.preSignedUrl,
        nameS3: a.fileName,
        nameUser: fileMatch?.name || null,
        code: fileMatch?.code || null,
        file: fileMatch?.file || null
      } as IPreSignedUrlObject;
    });
    this.pushFilesToS3();
  }

  pushFilesToS3() {
    this.putUrls
      .filter((el) => el.file !== null)
      .forEach((pushable) => {
        this.putFileToS3(pushable);
      });
  }

  putFileToS3(pushable: IPreSignedUrlObject) {
    this.uploadDocumentsS3
      .pushFilePresigned(pushable.urlS3, pushable.file)
      .subscribe({
        next: (res) => {
          if (res.status === 200) {
            this.attemptExceededPutFile = false;
            ++this.presignedFlag;
            this.reqUploadDNIS3.frontKey && this.reqUploadDNIS3.backKey
              ? this.uploadDocument()
              : this.callSQS();
          } else if (!this.attemptExceededPutFile) {
            this.attemptExceededPutFile = true;
            this.putFileToS3(pushable);
          } else {
            this.analytic.uTagLinkError(
              'Error cargando documento en S3 status: ' + res.status,
              'error_tech_page'
            );
            this.router.navigate([
              routesData.ERRORS.GENERAL_ERROR.redirectPath
            ]);
          }
        },
        error: (error) => {
          if (!this.attemptExceededPutFile) {
            this.attemptExceededPutFile = true;
            this.putFileToS3(pushable);
          } else {
            const errorMessage =
              error.message === undefined ? '' : error.message;
            const event =
              errorMessage === 'Unauthorized'
                ? 'error_user_page'
                : 'error_tech_page';
            this.analytic.uTagLinkError(
              'Error cargando documento en S3 ' + errorMessage,
              event
            );
            if (errorMessage !== 'Unauthorized') {
              this.router.navigate([
                routesData.ERRORS.GENERAL_ERROR.redirectPath
              ]);
            }
          }
        }
      });
  }

  callSQS() {
    const dataRequest: ISqs = {
      documentNumber: this.customerDataSvc.customerData.numberDNI,
      documentTypeCode:
        this.customerDataSvc.customerData.documentType === 'CC' ? 'C' : 'E',
      product: 'CDT',
      filingOfficeCode: 640,
      economicActivityCode:
        this.customerDataSvc.customerData.economicActivityInformation
          .economicActivity === EnumEconomicActivity.IndependentWithBusiness
          ? 4
          : this.customerDataSvc.customerData.economicActivityInformation
              .economicActivity,
      originProductNumber:
        this.customerDataSvc.customerData.resultCPP.requestCode.toString(),
      originProductCode: 1,
      subProductType:
        this.customerDataSvc.customerData.accountType === 'CUENTA_SIMPLE'
          ? 5
          : 1,
      files: [...this.completeDocIdList, ...this.workCertificatesDocsList].map(
        (document) => {
          return {
            documentaryCode: document.code,
            filename: document.nameS3
          };
        }
      )
    };

    this.sqsService.sendSQS(dataRequest).subscribe({
      next: () => {
        if (
          this.presignedFlag ===
          [
            ...this.frontIdList,
            ...this.backIdList,
            ...this.workCertificatesDocsList
          ].length
        ) {
          this.moreInfoService.setMoreInfo({
            ...this.moreInfoService.moreInfoData,
            isUploadedAnyDoc: true
          });
          this.router.navigate([routesData.DIGITAL_SIGNATURE.redirectPath]);
        } else {
          this.showDialogErrorFiles();
        }
      },
      error: (error) => {
        error.status === 401
          ? this.router.navigate([routesData.ERRORS.TIME_ERROR.redirectPath])
          : this.openDocumentsToChargeDialog();
      }
    });
  }

  openDocumentsToChargeDialog(): void {
    this.dialogOptionsService.openDocumentsToChargeDialog(
      'documentsToChargeDialogComponent'
    );
  }

  convert2Image(
    numbDoc: string,
    txType: string,
    nameDoc: string,
    sendFile: any
  ) {
    this.convertPDF2Image.convertPFD2Image(numbDoc, txType, nameDoc).subscribe({
      next: () => {
        this.attemptExceededConvertPdf = false;
        this.validateDocument(sendFile, true);
      },
      error: (error) => {
        if (!this.attemptExceededConvertPdf) {
          this.attemptExceededConvertPdf = true;
          this.convert2Image(numbDoc, txType, nameDoc, sendFile);
        } else {
          let errorMessage = '';
          if (error?.message !== undefined) {
            errorMessage = error.message;
          }
          const event =
            errorMessage === 'Unauthorized'
              ? 'error_user_page'
              : 'error_tech_page';
          this.analytic.uTagLinkError(
            'Error servicio convert-pdf-to-image ' + errorMessage,
            event
          );
          if (errorMessage !== 'Unauthorized') {
            this.router.navigate([
              routesData.ERRORS.GENERAL_ERROR.redirectPath
            ]);
          }
        }
      }
    });
  }

  spliceArray(
    control: AbstractControl,
    array: IArrayFiles[],
    index: number
  ): void {
    array.splice(index, 1);
    this.deleteFile(control);
  }

  deleteFileArray(
    control: AbstractControl,
    array: IArrayFiles[],
    index: number
  ): void {
    this.spliceArray(control, array, index);
  }

  deleteFileArrayID(
    control: AbstractControl,
    array: IArrayFiles[],
    index: number
  ): void {
    --this.presignedFlag;
    this.spliceArray(control, array, index);
    this.uploadIDSuccess = false;
  }

  deleteFile(control: AbstractControl): void {
    control.setValue(null);
  }

  // Servicio de validación
  validateAndUploadDni(file: IArrayFiles[], isPersonal: boolean): void {
    const fileIdS3: IFilesPreSignedUrl = {
      files: [...file.map((el) => el.nameS3)],
      personalDoc: isPersonal
    };
    this.createFilePresignedUrl(fileIdS3, file);
  }

  createFilePresignedUrl(
    fileIdS3: IFilesPreSignedUrl,
    file: IArrayFiles[]
  ): void {
    this.generatePresignedUrl.createURL(fileIdS3).subscribe({
      next: (res) => {
        if (res.status === 201) {
          this.attemptExceededUrlPresigned = false;
          this.pushSingleFileToS3(res.body as IResponsePresignedUrl, file);
        } else if (!this.attemptExceededUrlPresigned) {
          this.attemptExceededUrlPresigned = true;
          this.createFilePresignedUrl(fileIdS3, file);
        } else {
          this.analytic.uTagLinkError(
            'Error servicio generate-presigned-url status: ' + res.status,
            'error_tech_page'
          );
          this.router.navigate([routesData.ERRORS.GENERAL_ERROR.redirectPath]);
        }
      },
      error: (error) => {
        if (!this.attemptExceededUrlPresigned) {
          this.attemptExceededUrlPresigned = true;
          this.createFilePresignedUrl(fileIdS3, file);
        } else {
          let errorMessage = '';
          if (error?.message !== undefined) {
            errorMessage = error.message;
          }
          const event =
            errorMessage === 'Unauthorized'
              ? 'error_user_page'
              : 'error_tech_page';
          this.analytic.uTagLinkError(
            'Error servicio generate-presigned-url ' + errorMessage,
            event
          );
          if (errorMessage !== 'Unauthorized') {
            this.router.navigate([
              routesData.ERRORS.GENERAL_ERROR.redirectPath
            ]);
          }
        }
      }
    });
  }

  pushSingleFileToS3(fileForSend: any, file: IArrayFiles[]) {
    const adlchannel = 'CDT';
    const sendFile = fileForSend.preSignedUrl[0];
    this.uploadDocumentsS3
      .pushFilePresigned(sendFile.preSignedUrl, file[0].file)
      .subscribe({
        next: () => {
          this.attemptExceededPutFile = false;
          const file2valid = sendFile.fileName;
          if (file2valid) {
            const name2convert = file2valid.split('.').shift();
            const type2valid = file2valid.split('.').pop();
            if (type2valid === 'pdf' || type2valid === 'PDF') {
              const validcase = name2convert.split('-').pop();
              if (validcase === 'F' || validcase === 'B') {
                this.convert2Image(
                  this.customerDataSvc.customerData.numberDNI,
                  adlchannel,
                  name2convert,
                  sendFile
                );
                ++this.presignedFlag;
              }
            } else {
              this.validateDocument(sendFile, false, type2valid);
              ++this.presignedFlag;
            }
          }
        },
        error: (error) => {
          if (!this.attemptExceededPutFile) {
            this.attemptExceededPutFile = true;
            this.pushSingleFileToS3(fileForSend, file);
          } else {
            const errorMessage =
              error.message === undefined ? '' : error.message;
            const event =
              errorMessage === 'Unauthorized'
                ? 'error_user_page'
                : 'error_tech_page';
            this.analytic.uTagLinkError(
              'Error cargando documento a S3 ' + errorMessage,
              event
            );
            if (errorMessage !== 'Unauthorized') {
              this.router.navigate([
                routesData.ERRORS.GENERAL_ERROR.redirectPath
              ]);
            }
          }
        }
      });
  }

  validateDocument(document: any, fromConvert: boolean, extension?: string) {
    const ext = fromConvert ? 'png' : extension;
    const split = document.fileName.split('.');
    const disposition = split[0].substring(split[0].length - 1);
    const firstName = this.customerDataSvc.customerData.firstName;
    const lastName = this.customerDataSvc.customerData.lastName;
    const requestValidateObject: IRequestValidateDocument = {
      disposition,
      nameDocument: `${document.fileName.split('.').shift()}.${ext}`,
      firstName,
      lastName
    };
    this.validateDocumentsService
      .validateDocument(requestValidateObject)
      .subscribe({
        next: (res) => {
          this.handleResponseValidateDoc(res, document);
        },
        error: (error) => {
          this.handleErrorValidateDoc(error);
        }
      });
  }

  handleResponseValidateDoc(res: any, document: any) {
    if (res.status === 200 || res.status === 206) {
      const name2convert = document.fileName.split('.').shift();
      const validcase = name2convert.split('-').pop();
      if (!res.body.isValid) {
        const control =
          validcase === 'F' ? this.controlFrontIdPic : this.controlBackIdPic;

        const memoryFile =
          validcase === 'F' ? this.frontIdList : this.backIdList;

        this.deleteFileArrayID(control, memoryFile, 0);

        this.setErrorInvalidDNI(control);
      } else if (validcase === 'F') {
        this.reqUploadDNIS3.frontKey = document.fileName;
      } else {
        this.reqUploadDNIS3.backKey = document.fileName;
      }
    }
  }

  handleErrorValidateDoc(error: any) {
    let errorMessage = '';
    if (error?.message !== undefined) {
      errorMessage = error.message;
    }
    const event =
      errorMessage === 'Unauthorized' ? 'error_user_page' : 'error_tech_page';
    this.analytic.uTagLinkError(
      'Error servicio validate-document ' + errorMessage,
      event
    );
    if (errorMessage !== 'Unauthorized') {
      this.router.navigate([routesData.ERRORS.GENERAL_ERROR.redirectPath]);
    }
  }

  uploadDocument() {
    this.uploadDNIS3.uploadDNI(this.reqUploadDNIS3).subscribe({
      next: (res2) => {
        if (res2.status === 201) {
          this.uploadIDSuccess = true;

          this.completeDocIdList = [
            {
              name: `${codesUploadDocuments.identificationCard.prefix}-${this.customerDataSvc.customerData.numberDNI}`,
              code: codesUploadDocuments.identificationCard.code,
              nameS3: `${codesUploadDocuments.identificationCard.prefix}-${this.customerDataSvc.customerData.numberDNI}.pdf`
            }
          ];

          this.callSQS();
        } else {
          this.analytic.uTagLinkError(
            'Error servicio save-document status: ' + res2.status,
            'error_tech_page'
          );
          this.router.navigate([routesData.ERRORS.GENERAL_ERROR.redirectPath]);
        }
      },
      error: (error) => {
        let errorMessage = '';
        if (error?.message !== undefined) {
          errorMessage = error.message;
        }
        const event =
          errorMessage === 'Unauthorized'
            ? 'error_user_page'
            : 'error_tech_page';
        this.analytic.uTagLinkError(
          'Error servicio save-document ' + errorMessage,
          event
        );
        if (errorMessage !== 'Unauthorized') {
          this.router.navigate([routesData.ERRORS.GENERAL_ERROR.redirectPath]);
        }
      }
    });
  }

  private uniqueArray(array: any[]): any[] {
    return array.filter((item, index) => {
      const thing = JSON.stringify(item);
      return (
        index ===
        array.findIndex((obj) => {
          return JSON.stringify(obj) === thing;
        })
      );
    });
  }

  setErrorInvalidDNI(control: AbstractControl) {
    control.setErrors({ invalidDNI: true });
    control.markAsTouched();
  }

  private toBase64(file: File): Observable<string | ArrayBuffer> {
    return new Observable((observer) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const result: string = reader.result as string;
        observer.next(result);
      };
    });
  }

  private hasErrorFiles(
    control: AbstractControl,
    files: FileList | File[],
    allowedFiles: string[] = this.allowedFile,
    maxSize: number = this.MAX_SIZE
  ): boolean {
    if (!files && !files['length']) {
      return true;
    }

    if (
      Array.from(files).some((el) => {
        return el.size / 1024 / 1024 > maxSize;
      })
    ) {
      control.setErrors({ maxFileSize: true });
      return true;
    }

    if (Array.from(files).some((el) => !allowedFiles.includes(el.type))) {
      control.setErrors({ incorrectMimeType: true });
      return true;
    }

    if (
      control === this.controlWorkCertificate &&
      (files.length > this.MAX_FILES ||
        this.workCertificatesDocsList.length + files.length > this.MAX_FILES)
    ) {
      control.setErrors({ maxFiles: true });
      return true;
    }

    if (
      control === this.controlIndependentDocument &&
      (files.length > this.MAX_FILES ||
        this.independentDocsList.length + files.length > this.MAX_FILES)
    ) {
      control.setErrors({ maxFiles: true });
      return true;
    }

    return false;
  }
}
